export const API_ENDPOINTS = {
  INSURANCEPLAN: {
        SEARCH_PLANGROUP: "PlanGroup/Search",
        EXPORT_PLANGROUP: "PlanGroup/Export",
        SAVE_PLANGROUP: "PlanGroup/Save",
        GET_PLANGROUP_BY_ID: "PlanGroup/GetById",
        UPDATE_PLANGROUP: "PlanGroup/Update",
        DELETE_PLANGROUP: "PlanGroup/Delete",

        GET_PLAN: "Plan/Search",
        SAVE_PLAN: "Plan/Save",
        CLONE_PLAN: "Plan/Clone",
        GET_PLAN_BY_ID: "Plan/GetById",
        UPDATE_PLAN: "Plan/Update",
        DELETE_PLAN: "Plan/Delete",
        GET_DROPDOWN_DATA: "Plan/GetPlanByGroupIdDropdown",
        EXPORT_PLANSETUP: "Plan/Export",

        GET_COMPANY_SERVICES: "CompanyService/Search",

        SEARCH_SERVICETYPE: "ServiceType/Search",
        SAVE_SERVICETYPE: "ServiceType/Save",
        GET_SERVICETYPE_BY_ID: "ServiceType/GetById",
        UPDATE_SERVICETYPE: "ServiceType/Update",
        DELETE_SERVICETYPE: "ServiceType/Delete",

    // Add other  endpoints here
  },
 
};

export const QUERY_KEYS = {
    INSURANCEPLAN: {
        PLANGROUPS: ["PlanGroupSearch"], // UNIQUE IN OVER ALL APPLICATION
        SERVICETYPES: ["ServiceTypeSearch"],
        PLANS: ["PlanSearch"],
  },
  
};